export default "__VITE_ASSET__N6zj$1D3__"